import { useId } from '@/hooks';
import { dateFormat } from '@/utils';
import { useSnapshot } from '../../_hooks/useSnapshot';

export const useSnapshotTitle = () => {
  const { id } = useId();
  const snapshot = useSnapshot({ id });

  const title = snapshot.data
    ? `${snapshot.data?.name || ''}（${dateFormat({
        datetime: snapshot.data?.referenceDate ?? '',
      })}）`
    : '';
  return { title };
};
